import { render, staticRenderFns } from "./PerformButtons.vue?vue&type=template&id=758fe915&scoped=true"
import script from "./PerformButtons.vue?vue&type=script&lang=js"
export * from "./PerformButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758fe915",
  null
  
)

export default component.exports